import { FaCheck, FaMinus } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

export const FieldCheckbox = ({
    id, name, label, hint, error, text, value,
    isChecked, isIndeterminate = false, onChange,
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {
    const DOM_ID = useDomFieldId(id);
    const CHECKED = typeof isChecked === 'boolean' ? isChecked : Boolean(value);
    const CHECK_TEXT = text ?? label;

    return (
        <FieldShell
            id={DOM_ID}
            label={null}
            hint={hint}
            error={error}
            layout="inline"
            isRequired={isRequired}
            isDisabled={isDisabled}
            span={span}
        >
            <label className={`${BLOCK}__check`} htmlFor={DOM_ID}>
                <input
                    id={DOM_ID}
                    data-field={name ?? id}
                    name={name ?? id}
                    type="checkbox"
                    className={`${BLOCK}__check_input`}
                    checked={CHECKED}
                    onChange={onChange}
                    required={isRequired}
                    disabled={isDisabled}
                    aria-invalid={!!error}
                    {...rest}
                />

                <span className={`${BLOCK}__check_box`} aria-hidden="true">
                    {isIndeterminate ? <FaMinus /> : <FaCheck />}
                </span>

                {CHECK_TEXT && (
                    <span className={`${BLOCK}__check_text`}>
                        {CHECK_TEXT}
                        {isRequired && <span className={`${BLOCK}__required`} aria-hidden="true">*</span>}
                    </span>
                )}
            </label>
        </FieldShell>
    );
};
